import qs from 'querystring'

export default class DetectApp {
	static install(Vue, { param = 'app' } = {}) {
		// Detect presence of specific param in URL
		const { origin, pathname, search } = window.location
		const queryObj = qs.parse(search.replace(/^\??/, ''))

		if (param in queryObj) {
			// Flag that we're in app mode
			Vue.prototype.$isApp = true
			Vue.prototype.$appHeightOffset = 40

			// Navigate to new URL without query param if we can
			if ('history' in window) {
				delete queryObj[param]
				const queryStr = qs.stringify(queryObj)
				const target = [origin + pathname, queryStr].filter(Boolean).join('?')
				window.history.replaceState({}, document.title, target)
			}
		} else {
			// Do nothing
			Vue.prototype.$isApp = false
			Vue.prototype.$appHeightOffset = 0
		}
	}
}
